import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CoreService } from '../core/core.service';
import { TransactionService } from './transaction.service';
import { Main } from '../core/main.service';

@Component({
  selector: 'cp-offers',
  templateUrl: './offers.component.html',
})

export class OffersComponent {

  offer: any;
  options: any;
  file: any;
  isLoading: any;
  id: string;
  offerForm!: FormGroup;
  config: any;
  operation: string;
  selectedSale: any;
  selectedBuyer: any;

  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  sales: any[];
  offers: any[];
  awards: any[];
  ekubMembers: any[];

  constructor(private route: ActivatedRoute,
    private formBuilder: FormBuilder, private mainService: Main, private coreService: CoreService, private api: TransactionService, private router: Router,
    @Inject(Restangular) public Restangular) {
    this.offer = {
      'title': '',
      'position': 0,
      'remark': ''
    };
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.filter = '';
    this.isLoading = false;
    if (this.route.queryParams['value']['id']) {
      this.id = this.route.queryParams['value']['id'];
    }
    this.operation = 'add';
  }

  get offered_price() { return this.offerForm.get('offered_price'); }
  get user() { return this.offerForm.get('user'); }
  get sale() { return this.offerForm.get('sale'); }
  get status() { return this.offerForm.get('status'); }
  get remark() { return this.offerForm.get('remark'); }

  ngOnInit() {
    this.createForm();
    //this.getAllAwards();
    this.getAllSales();
    this.getOffers();
  }


  getWinner(event: any) {
    debugger;
    const result = this.sales.filter(
      (sale: any) => sale.id.toLowerCase().indexOf(event.id.toLowerCase()) !== -1
    );
    this.selectedSale = result[0];
    this.getEkubMembers(result[0].award.data.ekub.data.id);
  }

  getEkubMembers(ekubId: any) {
    debugger;
    this.api.getEkubMembers(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        if (this.selectedSale) {
          var index = this.ekubMembers.map(x => {
            return x.id;
          }).indexOf(this.selectedSale.award.data.winner.data.id);
          this.ekubMembers.splice(index, 1);
        }
        for (let member of this.ekubMembers) {
          member.text = member.username + ' - ' + member?.pivot?.code;
          member.id = member.id;
        }
      }
    });
  }

  getAllSales() {
    var options = "&status=pending";
    this.api.getAllSales(options).subscribe((resp: any) => {
      debugger;
      this.sales = resp.data;
      for (let sale of this.sales) {
        sale.text = sale?.award.data.ekub?.data?.ekub_id + ' - ' + sale?.award?.data?.code + ' - ' + sale.min_offer + ' ETB - ' + sale?.award.data.winner?.data?.username;
        sale.id = sale.id;
      }
    }, (err) => {
      debugger;
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });
    });
  }

  /*  getAllAwards() {
     var filter = '&status=drawed';
     this.api.getAllAwards(filter).subscribe((resp: any) => {
       debugger;
       this.awards = resp.data;
       for (let award of this.awards) {
         award.text = award?.ekub?.data?.ekub_id + ' - ' + award?.user?.data?.username;
         award.id = award.id;
       }
     }, (err) => {
       debugger;
       
     });
   } */


  getOffers() {
    debugger;
    this.api.getOffers(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.offers = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      debugger;
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  private createForm() {

    this.offerForm = this.formBuilder.group({
      offered_price: [0, [Validators.required,]],
      sale: ['', [Validators.required]],
      user: ['', [Validators.required]],
      status: ['pending', [Validators.required]],
      remark: [''],
    });
  }

  getOffer() {
    this.api.getOffer(this.id).subscribe((res: any) => {
      debugger;
      this.offer = res.data;
      this.offerForm.setValue(res.data);
    });
  }

  setBuyer(event) {
    debugger;
    this.selectedBuyer = event;
  }


  fileChange(event): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.file = fileList[0];
    }
  }

  changeStatus(id: any, status: any) {
    this.api.changeOfferStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getOffers();
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'error' });

    });
  }

  addOffer() {
    debugger;
    if (this.selectedSale.min_offer > this.offered_price.value) {
      this.mainService.toast({ title: 'Error', body: 'Offered price cannot be less than min offer price of: ' + this.selectedSale.min_offer, type: 'danger' });

    } else {
      this.isLoading = !this.isLoading;
      var id = this.offer.id;
      this.offer = this.offerForm.value;
      this.offer.code = this.selectedBuyer?.pivot?.code;
      this.api.createOffer(this.offer, id).subscribe((res: any) => {
        //this.api.createOffer({ offer: this.offer }, id).subscribe((res: any) => {
        debugger;
        this.isLoading = !this.isLoading;
        this.offerForm.reset();
        this.getOffers();
        this.mainService.toast({ title: 'Success', body: (this.id) ? 'Offer successfully updated! ' : 'Offer  successfully added!', type: 'dark' });
      }, (err) => {
        debugger;
        err = err;
        this.isLoading = !this.isLoading;
        this.mainService.toast({ title: 'Error', body: (err.data.detail) ? err.data.detail : (this.id) ? 'Could not update offer!' : 'Could not add offer!', type: 'danger' });

      });
    }

  }

  reset() {
    debugger;
    this.operation = 'add';
    this.offerForm.reset();
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getOffers();
  }

  editOffer(offer: any) {
    debugger;
    this.offer = offer;
    this.offerForm.get('offered_price').setValue(offer.offered_price);
    this.offerForm.get('award').setValue(offer.award.data.id);
    this.offerForm.get('status').setValue(offer.status);
    this.offerForm.get('remark').setValue(offer.remark);
    this.operation = 'update';
  }

}
